RA.CommunityBrowser = {
  init(community) {
    this.community = community;

    if (!RA.Utils.isDigits(this.community.id)) {
      this.showInvalidCommunity();
      return;
    }

    this.setVariables();
    this.bindEvents();

    this.refreshTitle();
    this.refreshTopics();
    this.updateCommunityContext();

    RA.showOverlay(this.$content);
    RA.CommunitySearch.search(this.createQuery(), this.initSearchDone.bind(this));
  },
  setVariables() {
    this.$quickSearches = $("#commQuickSearches");
    this.$content = $("#commBrowserContent");
    this.source = "all";
    this.filterTopicIDs = [];
    this.pageNumber = 1;
  },
  loadSource() {
    let source = this.source;

    RA.showOverlay(this.$content);

    if (source == "trending") {
      this.loadTrending();
    } else if (source == "latest") {
      this.loadLatest();
    } else if (source == "noreplies") {
      this.loadNoReplies();
    } else {
      this.loadAll();
    }
  },
  bindEvents() {
    this.$quickSearches.find("a").on("click", this.quickSearchClicked.bind(this));
  },
  loadAll() {
    let query = this.createQuery();
    query.sortBy = "last_modified_date";

    RA.CommunitySearch.search(query, this.searchDone.bind(this));
  },
  loadTrending() {
    let url = Config.contextPath + "/controller/socialsearch/trending/";

    $.get(url, this.createQuery())
      .done(this.otherDone.bind(this))
      .fail(RA.handleAjaxError);
  },
  loadLatest() {
    let url = Config.contextPath + "/controller/socialsearch/latest/";

    $.get(url, this.createQuery())
      .done(this.otherDone.bind(this))
      .fail(RA.handleAjaxError);
  },
  loadNoReplies() {
    let query = this.createQuery();
    query.startAnswerCount = 0;
    query.endAnswerCount = 0;
    query.descending = false;

    RA.CommunitySearch.search(query, this.searchDone.bind(this));
  },
  createQuery() {
    let query = {communityID: this.community.id,
      sortBy: "last_modified_date",
      descending: true};

    if (this.filterTopicIDs.length != 0) {
      query.topicID = this.filterTopicIDs.join(";");
    }

    if (this.pageNumber > 1) {
      query.currentpage = this.pageNumber;
    }

    return query;
  },
  resetFilter() {
    this.filterTopicIDs = [];
    this.pageNumber = 1;
  },
  initSearchDone(searchResults) {
    this.showHits(searchResults);
    this.refreshTitle(searchResults);
    RA.hideOverlay(this.$content);
    this.updateTopicCounts(searchResults.topics);
    this.refreshTopics();

    let topicIDs = RA.Utils.getQueryParam("topicID");
    let doTopicFilter = false;

    if (RA.Utils.isNotBlank(topicIDs)) {
      topicIDs = topicIDs.split(";")
        .filter(RA.Utils.isDigits)
        .map(idStr => parseInt(idStr));

      let allTopicIDs = this.community.topics.map(t => t.id);
      topicIDs = topicIDs.filter(id => allTopicIDs.indexOf(id != -1));
      doTopicFilter = topicIDs.length > 0;
    }

    let source = RA.Utils.getQueryParam("source");
    let doSourceChange = RA.Utils.isNotBlank(source) && source !== "all";

    let pageNumber = RA.Utils.getQueryParam("page");
    let doPageChange = RA.Utils.isDigits(pageNumber) && pageNumber != 1;

    if (doSourceChange) {
      this.source = source;
      this.$quickSearches.find("a[href='#" + this.source + "']").tab("show");
    }
    if (doTopicFilter) {
      this.filterTopicIDs = topicIDs;
      this.updateCommunityContext()
    }
    if (doPageChange) this.pageNumber = pageNumber;

    if (doTopicFilter || doSourceChange || doPageChange) {
      this.loadSource();
    }
  },
  searchDone(searchResults) {
    if (this.filterTopicIDs.length == 0) {
      this.updateTopicCounts(searchResults.topics);
    }

    this.showHits(searchResults);
    RA.hideOverlay(this.$content);
    this.refreshTopics();
  },
  otherDone(searchResults) {
    if (this.filterTopicIDs.length == 0) {
      let topicCounts = this.getTopicCountsFromHits(searchResults.results);
      this.updateTopicCounts(topicCounts);
    }

    this.showHits(searchResults);
    RA.hideOverlay(this.$content);
    this.refreshTopics();
  },
  quickSearchClicked(e) {
    let $link = $(e.currentTarget);
    let target = $link.attr("href").substring(1);

    if (target == this.source) {
       return false;
    }

    this.$quickSearches.find(".active").removeClass("active");
    $link.closest("li").addClass("active");

    this.source = target;
    this.resetFilter();
    this.loadSource();
    this.updateHistory();

    return false;
  },
  resetTopicsClicked() {
    this.filterTopicIDs = [];
    this.loadSource();
    this.updateCommunityContext();
    this.updateHistory();
  },
  pageClicked(num) {
    this.pageNumber = num;

    window.scrollTo(0, this.$content.offset().top - 60);

    this.loadSource();

    this.updateHistory();
  },
  topicClicked(id) {
    if (this.filterTopicIDs.length && this.filterTopicIDs[0] == id) {
      return;
    }

    this.filterTopicIDs = [ id ];

    this.pageNumber = 1;
    this.loadSource();
    this.updateCommunityContext();
    this.updateHistory();
  },
  refreshTitle(searchResults) {
    let totalHits = "-";
    let countLabel = "questions";
    let topicLabel = this.community.topics.length == 1 ? "topic" : "topics";

    if (searchResults) {
       countLabel = searchResults.totalHits == 1 ? "question" : "questions";
       totalHits = searchResults.totalHits;
    }

    ReactDOM.render(
      <CommunityTitle community={this.community}
        className="-lg">
        <div className="text-muted">
          {`${totalHits} ${Labels.getLabel(countLabel)}`}
          {" | "}
          {`${this.community.topics.length} ${Labels.getLabel(topicLabel)}`}
          {" | "}
          <a href={`${Config.contextPath}/controller/post/discussion/?communityID=${this.community.id}`} data-action="post">
            {Labels.getLabel("Post your question")}
          </a>
        </div>
      </CommunityTitle>,
      document.getElementById("communityTitle")
    );
  },
  showHits(searchResults) {
    let hits = searchResults.results;
    let pagerDetail = searchResults.pagerDetail;

    if (hits.length == 0) {
      ReactDOM.render( this.getNoContent(), document.getElementById("commResults"));
      return;
    }

    let questionLabel = hits.length == 1 ? "question" : "questions";
    let pager = hits.length > 0 && pagerDetail && pagerDetail.totalPages > 1 ?
      <ResultsPager pagerDetail={pagerDetail}
        onPageClicked={this.pageClicked.bind(this)} />
      : null;

    ReactDOM.render(
      <div className="">
        {this.getResultHeader(searchResults)}
        <CommResultsList hits={hits} />
        {pager}
      </div>,
      document.getElementById("commResults")
    );
  },
  refreshTopics() {
    ReactDOM.render(
      <TopicsFilter topics={this.community.topics}
        selectedTopicsIDs={this.filterTopicIDs}
        onTopicClicked={this.topicClicked.bind(this)}
        onResetClicked={this.resetTopicsClicked.bind(this)} />,
      document.getElementById("commTopics")
    );
  },
  getResultHeader(searchResults) {
    let totalHits = searchResults.totalHits ? searchResults.totalHits : searchResults.results.length;
    let pagerDetail = searchResults.pagerDetail;
    let pageStart = 0;
    let pageEnd = 0;
    let questionLabel = totalHits == 1 ? "question" : "questions";

    if (pagerDetail) {
      pageStart = pagerDetail.pageStart;
      pageEnd = pagerDetail.pageEnd;
    }

    return (
      <div className="result-col__head">
        <ResultCountSummary totalHits={totalHits}
          pageStart={pageStart}
          pageEnd={pageEnd}
          resultName={Labels.getLabel(questionLabel)} />
      </div>
    )
  },
  getNoContent() {
      return (
        <NoContent message={Labels.getLabel("No matching questions found")} center={false} />
      );
  },
  showInvalidCommunity() {
    ReactDOM.render(
      <AlertMessage alertType="danger">
        <strong>{Labels.getLabel("Error")}</strong>:
        {" " + Labels.getLabel("The community you are trying to access does not exist.") + " "}
        <a href={`${Config.contextPath}/${Config.portalInterface}/?tabname=communities`} className="alert-link">
          {Labels.getLabel("Show all communities")}
        </a>
      </AlertMessage>,
      document.getElementById("communityBrowser")
    );
  },
  updateTopicCounts(topicData) {
    this.resetTopicCounts();

    topicData.forEach(topic => this.setTopicCount(topic.id, topic.hits));
  },
  resetTopicCounts() {
    this.community.topics.forEach(topic => topic.hits = 0);
  },
  setTopicCount(topicID, count) {
    this.community.topics.filter(topic => topic.id == topicID)[0].hits = count;
  },
  getTopicCountsFromHits(hits) {
    // create map with key=topicID, val=hitCount
    let countMap = hits.reduce((prevObj, currHit) => {
      if (prevObj[currHit.topic.id]) {
        prevObj[currHit.topic.id]++
      } else {
        prevObj[currHit.topic.id] = 1;
      }

      return prevObj;
    }, {});

    // Change to an array of objects {id: topicID, hits: hitCount}
    let topics = [];
    for (let topicID in countMap) {
      topics.push({id: topicID, hits: countMap[topicID]});
    }

    return topics;
  },
  updateCommunityContext() {
    let {community, filterTopicIDs} = this;

    let communityContext = { community: community };

    if (filterTopicIDs.length == 1) {
      let selectedTopic = community.topics.filter(t => t.id == filterTopicIDs[0]);
      if (selectedTopic.length == 1) {
        selectedTopic = selectedTopic[0];
        communityContext.topic = selectedTopic;
      }
    }

    RA.setCommunityContext(communityContext);
  },
  updateHistory() {
    if (!history.replaceState) return;

    let params = RA.Utils.getQueryParams();

    if (this.filterTopicIDs.length) {
      params.topicID = this.filterTopicIDs.join(";");
    } else {
      delete params.topicID;
    }

    if (this.pageNumber == 1) {
      delete params.page;
    } else {
      params.page = this.pageNumber;
    }

    params.source = this.source;

    history.replaceState({}, "", RA.Utils.buildQueryString(params));
  }
}


var TopicsFilter = React.createClass({
  propTypes: {
    topics: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedTopicsIDs: React.PropTypes.arrayOf(React.PropTypes.number),
    onTopicClicked: React.PropTypes.func,
    onResetClicked: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedTopicsIDs: [],
      onResetClicked: function() {}
    };
  },
  topicClicked(topic, e) {
    e.target.blur();

    if (this.props.onTopicClicked) {
      this.props.onTopicClicked(topic.id);
    }
  },
  createItem(topic) {
    let isSelected = this.props.selectedTopicsIDs.indexOf(topic.id) != -1;
    let hitCount = topic.hits ? topic.hits : 0;

    return (
      <a href="#" className={"button-group__item" + (isSelected ? " active" : "")} key={topic.id} onClick={this.topicClicked.bind(this, topic)}>
        <span className="button-group__item-count">{hitCount}</span>
        {topic.name}
      </a>
    );
  },
  render() {
    let allLink;

    allLink = (
      <a href="#" className={"button-group__item" + (this.props.selectedTopicsIDs.length == 0 ? " active" : "")} onClick={this.props.onResetClicked}>
        {Labels.getLabel("All Topics")}
      </a>
    );

    return (
      <div className="filter">
        <h4 className="filter__title">{Labels.getLabel("Topics")}</h4>

        <div className="filter__list button-group">
          {allLink}
          {this.props.topics.map(this.createItem)}
        </div>
      </div>
    )
  }
})